import { Outlet } from "react-router-dom";
import css from "./TopbarLayout.module.css";
import Navbar from "./Navbar";

export const NavbarLayout = () => {
  return (
    <div className={css.navbarLayout}>
      <Navbar />
      <Outlet />
    </div>
  );
};
